import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Image1 from "../assets/Faithjpg.jpg"; 
import Image2 from "../assets/Mark.jpg"; 
import Image3 from "../assets/Nzilani.jpeg"; 

const testimonials = [
  {
    image: Image1,
    name: "Faith Waruguru",
    quote: "Confessions of a Nutrition Freak has become my go-to resource for all things nutrition! The website offers an incredible range of nutrition tips, covering everything from meal planning and healthy recipes to advice on specific health conditions and dietary needs. The content is always easy to understand and backed by science, making it both reliable and practical. Whether you're looking to improve your eating habits, learn more about superfoods, or find guidance on managing health through diet, this site has it all. Highly recommended for anyone passionate about nutrition and wellness!",
  },
  {
    image: Image2,
    name: "Mark Peter",
    quote: "For the past few months, I've been a regular reader of Confessions of a Nutrition Freak; it has helped me change my thinking about nutrition and wellness. This blog has been a great resource, dispelling myths and offering helpful advice on eating a balanced diet. Even a novice may easily understand complicated ideas because of the engaging and instructive style in which different nutrition articles are presented. I value the emphasis on realistic and sustainable lifestyle adjustments as opposed to band-aid solutions. I wholeheartedly advise subscribing to Confessions of a Nutrition Freak if you're seeking a trustworthy and dependable source of nutrition information. Don't pass up the chance to join this incredible adventure!",
  },
  {
    image: Image3,
    name: "Karen Nzilani",
    quote: "I have learnt a lot from following Confessions of a Nutrition Freak. The blog is full of helpful information about nutrition and healthy living. It inspires me to eat better and take care of my health. The tips on meal planning and understanding what to eat have changed how I think about food. I appreciate the opportunity to learn from the content and apply it to my life. I highly recommend this blog to anyone who wants to learn more about nutrition and improve their health!",
  },
];

const Testimonials = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000, // Increase the speed to 5000ms (5 seconds)
    pauseOnHover: true,   // Pause the autoplay when hovering
  };

  return (
    <div className="bg-white font-poppins py-20">
      <div className="container mx-auto px-5 md:px-10">
        <h2 className="text-secondary text-4xl font-extrabold text-center mb-10">Testimonials</h2>
        <Slider {...settings}>
          {testimonials.map((testimonial, index) => (
            <div key={index} className="flex flex-col items-center text-left p-4 border border-gray-200 rounded-lg shadow-lg h-80"> {/* Increased height */}
              <img src={testimonial.image} alt={testimonial.name} className="w-20 h-20 rounded-full mb-2" />
              <h3 className="text-md font-semibold text-secondary mb-2">{testimonial.name}</h3>
              <p className="text-[#626262] text-md flex-1 overflow-y-auto" style={{ maxHeight: '10rem', paddingRight: '0.5rem' }}>
                {testimonial.quote}
              </p> {/* Increased height for the paragraph */}
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Testimonials;